import { render, staticRenderFns } from "./SaleChannelTables.vue?vue&type=template&id=3c3d1b72&"
import script from "./SaleChannelTables.vue?vue&type=script&lang=js&"
export * from "./SaleChannelTables.vue?vue&type=script&lang=js&"
import style0 from "./SaleChannelTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports